export function countByStatuses(lineItems) {
    return lineItems.reduce((acc, lineItem) => {
        const status = lineItem.status;

        if (!acc[status]) {
            acc[status] = 0;
        }

        acc[status]++;

        return acc;
    }, {});
}
